// Pushes a conversion event to the GTM/GA4 dataLayer with a language dimension.
// GA4 tags remain gated by Consent Mode v2 (no cookies before consent).
export function trackConversion(event, params = {}) {
    try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event, ...params });
    } catch (e) {
        /* dataLayer unavailable — ignored */
    }
}
